import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-echelon",
  "use": "icon-echelon-usage",
  "viewBox": "0 0 1228 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1228 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-echelon\"><defs><style type=\"text/css\"></style></defs><path d=\"M614.4 0h512a102.4 102.4 0 0 1 0 204.8H614.4a102.4 102.4 0 1 1 0-204.8zM512 409.6h614.4a102.4 102.4 0 0 1 0 204.8H512a102.4 102.4 0 1 1 0-204.8zM102.4 819.2h1024a102.4 102.4 0 0 1 0 204.8H102.4a102.4 102.4 0 1 1 0-204.8z\" p-id=\"22926\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol